var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSupportMeasure = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8808 6.74998L9.75 3.61935V6.74998H12.8808ZM13.5 15V8.25H8.625C8.41789 8.25 8.25 8.08211 8.25 7.875V3H4.5V15H13.5ZM3.75 16.5C3.33579 16.5 3 16.1642 3 15.75V2.25C3 1.83579 3.33579 1.5 3.75 1.5H9.59846C9.69793 1.5 9.79332 1.53952 9.86364 1.60986L14.8902 6.63716C14.9605 6.70748 15 6.80286 15 6.9023V15.75C15 16.1642 14.6642 16.5 14.25 16.5H3.75Z",
  fill: "#CCE3F0"
})));
export default SvgSupportMeasure;